export default function Legal() {
  return (
    <section className="bg-white border-t border-[#e8dfc8] py-10 px-5 sm:px-8 lg:px-16">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start gap-4">
          <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
            <i className="ri-information-line text-[#C9A84C] text-lg"></i>
          </div>
          <div className="space-y-2 text-[#bbb] text-xs leading-relaxed" style={{ fontFamily: 'DM Sans, sans-serif', lineHeight: '1.8' }}>
            <p>Esta página está de acordo com a resolução 2336/2023 do CFM.</p>
            <p>Os resultados são individuais, autorizados pelos pacientes, não constituem promessa ou garantia de resultados.</p>
            <p>Todo procedimento possui riscos que são informados pelo médico antes da realização do procedimento.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
